import script from "./OkrElementCipheredName.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementCipheredName.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementCipheredName.vue?vue&type=style&index=0&id=901a356a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-901a356a"]])

export default __exports__